import React, { Component } from 'react'
import nav from './_nav'
import { connect } from 'react-redux'
import * as pageService from '../../services/page'
import {navItem} from "./navItem";
import {renderSidebar} from "./renderSidebar"

class ResponsiveSidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navsInfo: {},
      renderSubMenu : false,
      submenuItems: {}
    }

    this.load = this.load.bind(this)
    this.activeRoute = this.activeRoute.bind(this)
  }

  componentWillMount() {
    this.setState({ navsInfo: nav })
    this.load()
  }

  load(state, instance) {
    return pageService.nav(state).then(data => {
      const navs = this.state.navsInfo
      navs.items[1].children = []
      data['hydra:member'].map(el => {
        const { title, ...updatedEl } = el
        updatedEl.name = el.title
        updatedEl.url = '/page/' + el.id
        navs.items[1].children.push(updatedEl)
      })

      navs.items[1].children.sort((a, b) => {
        return parseInt(a.menuScore) - parseInt(b.menuScore)
      })

      this.setState({ data: [] }, () => {
        this.setState({
          navsInfo: navs
        })
      })
    })
  }

  activeRoute(routeName, props) {
    // return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown'
  }

  render() {

    const manageSubMenu = (item) => {
      this.setState({renderSubMenu : true, submenuItems: item})
    }

    const backToMainMenu = (item) => {
      this.setState({renderSubMenu : false, submenuItems: {}})
    }

    // nav type
    const navType = (item, idx) => navItem(item, idx, manageSubMenu, backToMainMenu)

    // nav list
    const navList = items => {
      return items ? items.map((item, index) => navType(item, index)) : []
    }

    return  renderSidebar(this.props, this.state, navList, backToMainMenu)
  }
}

const mapStateToProps = state => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({})

module.exports = connect(mapStateToProps, mapDispatchToProps)(ResponsiveSidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/ResponsiveSidebar.js